import { Editor } from '@/features/editor/components/editor';
import React from 'react';

export function EditorMapRoute(): JSX.Element {
  return <Editor />;
}
